@if (wishList$ | async; as wishList) {
  @if (wishList?.entries?.length > 0) {
    <div class="d-none d-md-block d-lg-block d-xl-block">
      <div class="cx-item-list-header row">
        <div class="cx-item-list-desc col-md-6">
          {{ 'cartItems.description' | cxTranslate }}
        </div>
        <div class="cx-item-list-price col-md-3 col-lg-4">
          {{ 'uigWishList.itemPrice' | cxTranslate }}
        </div>
        <div class="cx-item-list-total col-md-3 col-lg-2">
        </div>
      </div>
    </div>
    @for (entry of wishList?.entries; track entry) {
      <div class="cx-item-list-row">
        <app-uig-wish-list-item
          [cartEntry]="entry"
          [isLoading]="loading$ | async"
          class="cx-wish-list-items"
          (remove)="removeEntry($event)">
        </app-uig-wish-list-item>
      </div>
    }
  } @else {
    <h4>{{ 'wishlist.empty' | cxTranslate }}</h4>
  }
}

